@if (sidebar()) {
<forge-icon-button tabindex="0" class="tyl-icon-button" aria-label="Tyler Assistant" (click)="toggleSidebar()">
    <forge-tooltip placement="bottom">Tyler Assistant</forge-tooltip>
    <forge-icon name="sparkles" style="--forge-icon-color: var(--_app-bar-foreground);"></forge-icon>
    @if (unreadCount() !== 0)
    {
        <forge-badge slot="badge">{{unreadCount()}}</forge-badge>
    }
</forge-icon-button>
}
